import {
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import IconBox from "components/icons/IconBox";
import { IconArrowDown } from "components/icons/Icons";
import { documentStatus } from "../helpers/documentHelpers";

interface StatusCellProps {
  value: string;
  onChangeDocumentStatus: (documentId: string, option: any) => void;
  documentId: string;
}

export function StatusCell({ value, onChangeDocumentStatus, documentId }: StatusCellProps) {
  const shadow = useColorModeValue(
    "0px 4px 50px rgba(0, 0, 0, 0.1)",
    "0px 4px 50px rgba(0, 0, 0, 0.1)"
  );

  return (
    <Flex align="center">
      <Menu>
        <MenuButton
          padding={"10px 10px 10px 15px"}
          backgroundColor="#F3F5F5"
          borderRadius="100px"
        >
          <Flex alignItems={"center"}>
            <Text
              fontSize={"14px"}
              lineHeight="24px"
              fontWeight={"400"}
              color="black"
            >
              {value
                ? documentStatus?.find((it) => it.id === Number(value))?.label
                : "-"}
            </Text>
            <IconBox
              marginLeft="10px"
              icon={<IconArrowDown width="24px" height="24px" />}
            />
          </Flex>
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="0px"
          mt="10px"
          borderRadius="20px"
          bg={"#FFF"}
          border="none"
        >
          <Flex
            flexDirection="column"
            p="10px 20px"
            fontSize={"14px"}
            lineHeight="24px"
            fontWeight={"400"}
            color="black"
          >
            {documentStatus.map((option, index: number) => (
              <MenuItem
                key={index}
                _hover={{ bg: "none" }}
                _focus={{ bg: "none" }}
                borderRadius="8px"
                padding="15px 0px"
                onClick={() => onChangeDocumentStatus(documentId, option)}
                borderBottom={
                  index < documentStatus.length - 1 ? "1px solid #F3F5F5" : ""
                }
              >
                <Text fontSize="sm">{option.label}</Text>
              </MenuItem>
            ))}
          </Flex>
        </MenuList>
      </Menu>
    </Flex>
  );
}
